import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssMedia } from "../../../../modules/content/components/AbyssMedia/AbyssMedia";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { IImageBlockProps } from "./ImageBlock.props";

export const ImageBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IImageBlockProps) => {
  if (!image) return null;

  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <AbyssCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <AbyssMedia
          aspectRatio={image.aspectRatio}
          className="abyss-instrument-frame"
          media={image.image}
          sizes="(min-width: 1280px) 1184px, calc(100vw - 48px)"
        />
      </div>
    </AbyssSection>
  );
};

ImageBlock.displayName = "Block::ImageBlock";
